import {ReactElement} from 'react'
import ToastContentTemplate from './ToastContentTemplate'
import {useToastWrapperTemplate} from '../hooks/useToastWrapperTemplate'
import {
    ToastWrapperDefaultTemplatePropTypes
} from '@assecobs-react-components/toaster/src/types/ToastWrapperDefaultTemplatePropTypes'
// @ts-ignore
import {I18nMessage} from "assecobs-faktor-web-common/index";
import {TemplateType} from "../types/TemplateType";

type InvalidAttachmentSizeToastType = {
    acceptedTypes: string,
    maxFileSize: number | string
}

interface ToastDangerInvalidAttachmentTypeTemplateType extends TemplateType {
    templateProps: InvalidAttachmentSizeToastType;
}

const ToastDangerInvalidAttachmentTypeTemplate = ({
                                                      templateProps,
                                                      removeToast,
                                                      id,
                                                      timeOut = 5000
                                                  }: ToastDangerInvalidAttachmentTypeTemplateType): ReactElement => {

    const {className, onAnimationEnd, onClose} = useToastWrapperTemplate({id, removeToast})
    const messageHeader = <I18nMessage id="fw.attachment.toast.invalidType"/>
    const messageBody = <I18nMessage id="fw.attachment.adding.invalidType.info" values={templateProps}/>

    return (
        <div className={`toastContainer--danger ${className}`} onAnimationEnd={onAnimationEnd}>
            <ToastContentTemplate onClose={onClose}
                                  content={{
                                      ...templateProps,
                                      header: messageHeader,
                                      body: messageBody
                                  }}
                                  timeOut={timeOut}/>
        </div>
    )
}

ToastDangerInvalidAttachmentTypeTemplate.propTypes = ToastWrapperDefaultTemplatePropTypes

export default ToastDangerInvalidAttachmentTypeTemplate